import { Component, OnInit } from '@angular/core';
import { Approved } from 'src/app/service/modal/approved';
import { ActivatedRoute } from '@angular/router';
import { MailViewService } from 'src/app/service/apiservice/mailview.service';
import { Globals } from '../../../globals';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-stared-view-mobile',
  templateUrl: './stared-view-mobile.component.html',
  styleUrls: ['./stared-view-mobile.component.css']
})
export class StaredViewMobileComponent implements OnInit {

  mailId: number;
  ViewData: Approved = new Approved();
  todayDate:any;

  constructor(private route: ActivatedRoute, private _mailService: MailViewService,private global:Globals) { }

  ngOnInit() {
    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.mailId = params['id']);
    this._mailService.GetCurrentMail(this.mailId)
      .subscribe((response) => {
        Object.assign(this.ViewData, response);
      }, error => {
         info_noti(error);
      })
      this.todayDate=new Date();
  }

  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }

}
